import React, { useEffect, useRef, useState } from 'react'
import './message-creator.styles.scss';
import MessageModal from './message-modal.component';
import linkifyHtml from 'linkify-html';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';

const MessageCreator = ({ 
    gameData, 
    latestMessage,
    role
}) => {

    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ divHeight, setDivHeight ] = useState('2rem');
    const [ showMessageModal, setShowMessageModal ] = useState(false);
    const [ message, setMessage ] = useState(null);
    const [ messageToEdit, setMessageToEdit ] = useState(null);
    const timeoutRef = useRef();

    useEffect(() => {
        const el = document.getElementById('message-card');
        if (!el) return;
        const height = el.offsetHeight;
        console.log(height);
        setDivHeight(height - 129);

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
    }, [])

    useEffect(() => {
        if (screenSize === 'mobile' || screenSize === 'tablet') {
            setDivHeight(200);
        }
    }, [screenSize])

    useEffect(() => {
        if (!latestMessage) return;
        timeoutRef.current = setTimeout(() => {
            setMessage(latestMessage.message);
        }, 500)
    }, [latestMessage])

    return (
        <div className='message-creator-container'>
            <div className='message-creator'>
                <div className='g-list-item message-box' style={{'height': divHeight + 'px'}}>
                    {
                        (latestMessage && message)
                        ?
                        <>
                            <p>{latestMessage.title}</p>
                            <div className='meta'>Posted {format(new Date(latestMessage.ts), "Pp")}</div>
                            <div className='meta' dangerouslySetInnerHTML={{__html: linkifyHtml(message, {'target': '_blank'})}}></div>
                        </>
                        :
                        <div className='meta'>No message currently posted</div>
                    }
                </div>
                <div className='g-space-0-5'></div>
                <div className='center-col'>
                    {/* <button 
                        className='g-button small-btn'
                        onClick={() => setShowMessageModal(true)}
                    >
                        Edit
                    </button> */}
                    <button 
                        className={`g-button small-btn ${role !== 'owner' && role !== 'manager' ? 'disabled' : ''}`}
                        onClick={() => setShowMessageModal(true)}
                    >
                        Create a News Item 
                    </button>
                </div>
            </div>
            <MessageModal
                gameData={gameData}
                show={showMessageModal}
                cancel={() => setShowMessageModal(false)}
                message={messageToEdit}
            />
        </div>
    )
}

export default MessageCreator